import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getLeftMenu, updateLeftMenu } from '../../../api/managerApi';
import './leftMenu.css';

function LeftMenuEdit({ menuId, onSuccess, onCancel }) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [form, setForm] = useState(null);

  const isLinkType = form?.type === 'link';
  const isUrlType = form?.type === 'url';
  const isActionType = form?.type === 'action';
  const isCategoryType = form?.type === 'category';

  useEffect(() => {
    if (!menuId) return;
    setLoading(true);
    getLeftMenu(menuId)
      .then(data => setForm({ ...data, is_active: String(Boolean(data.is_active)) }))
      .catch(err => {
        console.error('메뉴 조회 실패:', err);
        alert('메뉴 조회 실패');
      })
      .finally(() => setLoading(false));
  }, [menuId]);

  const handleChange = e => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!menuId) return;
    setSaving(true);
    try {
      const payload = {
        ...form,
        sort_order: Number(form.sort_order || 0),
        is_active: String(form.is_active) === 'true',
      };
      const updated = await updateLeftMenu(menuId, payload);
      if (onSuccess) {
        onSuccess(updated);
      } else {
        navigate('/manager/left-menu');
      }
    } catch (err) {
      console.error('메뉴 수정 실패:', err);
      alert('메뉴 수정 실패');
    } finally {
      setSaving(false);
    }
  };

  if (!menuId) return <div className="mgr-loading">수정할 메뉴가 선택되지 않았습니다.</div>;
  if (loading) return <div className="mgr-loading">로딩 중...</div>;
  if (!form) return <div className="mgr-loading">메뉴 데이터가 없습니다.</div>;

  return (
    <>
      <div className="mgr-panel-header">
        <div>
          <div className="mgr-panel-title">메뉴 수정</div>
          <div className="mgr-panel-subtitle">{form.label}</div>
        </div>
      </div>
      <div className="mgr-panel-body">
        <form onSubmit={handleSubmit}>
          <div className="mgr-section">
            <div className="mgr-section-title">기본 정보</div>
            <div className="mgr-section-body">
              <div className="row g-2">
                <div className="col-md-6">
                  <label className="form-label">메뉴 키 (menu_key)</label>
                  <input className="form-control form-control-sm" name="menu_key" value={form.menu_key || ''} onChange={handleChange} required />
                </div>
                <div className="col-md-6">
                  <label className="form-label">타입 (type)</label>
                  <select className="form-select form-select-sm" name="type" value={form.type || 'link'} onChange={handleChange}>
                    <option value="link">link</option>
                    <option value="url">url</option>
                    <option value="category">category</option>
                    <option value="action">action</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label">라벨 (label)</label>
                  <input className="form-control form-control-sm" name="label" value={form.label || ''} onChange={handleChange} required />
                </div>
                <div className="col-md-6">
                  <label className="form-label">아이콘 (icon)</label>
                  <input className="form-control form-control-sm" name="icon" value={form.icon || ''} onChange={handleChange} placeholder="예: fas fa-home" />
                </div>
              </div>
            </div>
          </div>

          {(isLinkType || isUrlType || isActionType) && (
            <div className="mgr-section">
              <div className="mgr-section-title">경로 설정</div>
              <div className="mgr-section-body">
                <div className="row g-2">
                  {isLinkType && (
                    <div className="col-md-8">
                      <label className="form-label">경로 (path)</label>
                      <input className="form-control form-control-sm" name="path" value={form.path || ''} onChange={handleChange} />
                    </div>
                  )}
                  {isUrlType && (
                    <>
                      <div className="col-md-8">
                        <label className="form-label">URL</label>
                        <input className="form-control form-control-sm" name="url" value={form.url || ''} onChange={handleChange} />
                      </div>
                      <div className="col-md-8">
                        <label className="form-label">세션 URL (session_url)</label>
                        <input className="form-control form-control-sm" name="session_url" value={form.session_url || ''} onChange={handleChange} />
                      </div>
                    </>
                  )}
                  {isActionType && (
                    <div className="col-md-8">
                      <label className="form-label">액션 (action)</label>
                      <input className="form-control form-control-sm" name="action" value={form.action || ''} onChange={handleChange} />
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}

          {isCategoryType && (
            <div className="mgr-section">
              <div className="mgr-section-title">카테고리 설정</div>
              <div className="mgr-section-body">
                <div className="row g-2">
                  <div className="col-md-6">
                    <label className="form-label">items_from</label>
                    <input className="form-control form-control-sm" name="items_from" value={form.items_from || ''} onChange={handleChange} />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">item_id_field</label>
                    <input className="form-control form-control-sm" name="item_id_field" value={form.item_id_field || ''} onChange={handleChange} />
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">item_label_field</label>
                    <input className="form-control form-control-sm" name="item_label_field" value={form.item_label_field || ''} onChange={handleChange} />
                  </div>
                  <div className="col-12">
                    <label className="form-label">path_template</label>
                    <input className="form-control form-control-sm" name="path_template" value={form.path_template || ''} onChange={handleChange} />
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="mgr-section">
            <div className="mgr-section-title">기타 설정</div>
            <div className="mgr-section-body">
              <div className="row g-2">
                <div className="col-12">
                  <label className="form-label">메뉴설명</label>
                  <textarea
                    className="form-control form-control-sm"
                    name="menu_context"
                    value={form.menu_context || ''}
                    onChange={handleChange}
                    rows={3}
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">정렬 순서</label>
                  <input className="form-control form-control-sm" type="number" name="sort_order" value={form.sort_order ?? 0} onChange={handleChange} />
                </div>
                <div className="col-md-3">
                  <label className="form-label">활성 상태</label>
                  <select className="form-select form-select-sm" name="is_active" value={String(form.is_active)} onChange={handleChange}>
                    <option value="true">활성</option>
                    <option value="false">비활성</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div className="mgr-form-footer">
        <button className="btn btn-primary btn-sm" onClick={handleSubmit} disabled={saving}>{saving ? '저장중...' : '저장'}</button>
        <button className="btn btn-outline-secondary btn-sm" type="button" onClick={() => (onCancel ? onCancel() : navigate(-1))}>취소</button>
      </div>
    </>
  );
}

export default LeftMenuEdit;
